import { mapState } from 'vuex';

export default {
    name: 'fastmenu',
    props: {
    },

    data : function(){

        return {
            loading : false,
        }

    },

    created : () => {

    },

    watch: {
      
    },
    computed: mapState({
        auth : state => state.auth,

        items : function(state){
            return _.filter(this.allitems, (item) => {
				return !item.features || _.find(item.features, (f) => {
					return state.features[f]
				})
			})
        },

		allitems : function(){

			return [
				{
					id : 'explore',
					text : 'menu.explore',
					icon : "fas fa-search",
					action : this.explore
				},

				{
					route : '/help',
					id : 'help',
					text : 'menu.help', 
					icon : "fas fa-info",
				}

			]
		}
    }),

    methods : {

		
        explore : function(){
			this.core.vueapi.explore()
		},

        close : function(){
            this.$emit('close')
        },

        open : function(item){
			if(item.route) {
				this.$router.push(item.route).catch(e => {})
			}

			if(item.action) item.action()
		},

        
        tohelp : function(){
            this.$router.push("/faq").catch(e => {})
        }
    },
}